$(window).on('load', function () {
  // Only show if not shown before
  if (!localStorage.getItem("tryus_popup_shown")) {
    setTimeout(function () {
   //   $("#shopify-section-try-us_popup").fadeIn();
    }, 500);
  }
});

// Close button → hides popup and mark it as shown
$(".close_popup2").click(function () {
  $("#shopify-section-try-us_popup").fadeOut();
  localStorage.setItem("tryus_popup_shown", "true"); // mark as shown
});

// Try Us button → always opens popup
$(".tryus_btn").click(function () {
  $("#shopify-section-try-us_popup").fadeIn();
});